
import React from 'react';
import { IntlProvider } from 'react-intl';
import { withRouter } from 'react-router-dom';
import Banner from './banner/Banner';
import Dashboard from './dashboard/Dashboard';
import Foot from './Foot';
import { StylesProvider } from '@material-ui/core/styles';
import { makeStyles, Container } from '@material-ui/core';
import initMultiLingual, { getLanguage } from '../../untils/initMultiLingual';


const useStyles = makeStyles((theme) => ({
    container: {
        maxWidth: "100%",
        height: "inherit",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
    }
}))

function Home(props) {

    const { search } = props.location;
    const { Country, Lang } = Object.fromEntries(new URLSearchParams(search.slice(1)).entries());
    console.log(Object.fromEntries(new URLSearchParams(search.slice(1)).entries()));
    console.log(Lang);
    const year = new Date().getFullYear();
    const classes = useStyles();

    const language = getLanguage(Lang);
    const languageContent = initMultiLingual({ language: Lang, country: Country})

    return (
        <IntlProvider locale={language} messages={languageContent}>
            <StylesProvider>
                <Container className={classes.container} disableGutters={true}>
                    <Banner Country={Country} Lang={Lang} />
                    <Dashboard Lang={Lang} Country={Country} />
                    <Foot year={year} Lang={Lang} Country={Country} />
                </Container>
            </StylesProvider>
        </IntlProvider>
    );
}

export default withRouter(Home);